import {
  AppBar,
  Dialog,
  IconButton,
  Slide,
  Step,
  StepLabel,
  Toolbar,
} from '@mui/material'
import React from 'react'
import CloseIcon from '@mui/icons-material/Close'
import { getActiveStep } from '../../Register/selectors'
import { useDimensions } from '../../../hooks/useDimensions'
import { actions } from '../../Register/reducer'
import { useDispatch, useSelector } from 'react-redux'
import { SelectUnitsComponent } from '../../SelectUnits'
import { UnitsMapComponent } from '../../SelectUnits/UnitsMap'
import { SummaryComponent } from '../../Summary'
import { PaymentComponent } from '../../Payment'
import { AddUnitsSteps } from '../../Register/config'
import { TransitionProps } from '@mui/material/transitions'
import { getIsLoading } from '../../App/selectors'
import { LoadingComponent } from '../../../components/loader'
import {
  RegisterPageSurface,
  RegisterStepper,
  RegisterWorkspace,
} from '../../Register/styled'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />
})

interface Props {
  onClose: () => void
}

export const ProfileUnitsModalComponent: React.FC<Props> = ({ onClose }) => {
  const activeStep = useSelector(getActiveStep)
  const isLoading = useSelector(getIsLoading)
  const dispatch = useDispatch()
  const { height } = useDimensions()

  React.useEffect(() => {
    dispatch(actions.onActiveStep(2))
  }, [])

  const getComponent = (step: number) => {
    switch (step) {
      case 2:
        return <SelectUnitsComponent />
      case 3:
        return <UnitsMapComponent />
      case 4:
        return <SummaryComponent />
      case 5:
        return <PaymentComponent />
      default:
        return <UnitsMapComponent />
    }
  }

  return (
    <Dialog fullScreen open onClose={onClose} TransitionComponent={Transition}>
      <AppBar sx={{ position: 'relative' }}>
        <LoadingComponent isLoading={isLoading} />
        <Toolbar sx={{ justifyContent: 'flex-end' }}>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <RegisterPageSurface className="portal-units-modal__surface">
        <RegisterStepper
          className="portal-units-modal__stepper"
          activeStep={activeStep}
        >
          {AddUnitsSteps.map(({ title, width }) => {
            return (
              <Step sx={{ minWidth: width, maxWidth: width }} key={title}>
                <StepLabel>{title}</StepLabel>
              </Step>
            )
          })}
        </RegisterStepper>
        <RegisterWorkspace
          className="portal-units-modal__workspace"
          contentHeight={height - 100}
        >
          {getComponent(activeStep)}
        </RegisterWorkspace>
      </RegisterPageSurface>
    </Dialog>
  )
}
